export default "__VITE_ASSET__XCWLGA6B__"